import TrialUnavailable from '@/components/trial/trial-unavailable';
import { TRIAL_PAGES_COMPONENTS } from '@/constants/trial-pages';
import type { TrialRenderTarget } from '@/utils/resolve-trial-render';

// Mantém o nome apesar de impróprio: 24 arquivos consomem este tipo, e renomear não muda
// comportamento nenhum. `plans` não é campo deste tipo: nenhum dos componentes de LP o lê (o único
// consumidor era o card component deletado), então não desce mais como prop.
export interface DefaultTrialProps {
  daysTrial: number;
  trialConfigId: number | null;
  trialPageId: number | null;
  isDisabledButton?: boolean;
}

interface TrialLayoutSwitcherProps {
  target: TrialRenderTarget;
  isDisabledButton?: boolean;
}

// Renderizador puro: quem decide qual bloco vence é resolveTrialRender. O caminho de cartão não
// existe mais — alvo que não resolve para componente do registry vira TrialUnavailable.
export const TrialLayoutSwitcher = ({ target, isDisabledButton = false }: TrialLayoutSwitcherProps) => {
  if (target.kind === 'unavailable') return <TrialUnavailable />;

  const TrialPageComponent = TRIAL_PAGES_COMPONENTS[target.componentKey];

  if (!TrialPageComponent) return <TrialUnavailable />;

  return <TrialPageComponent daysTrial={target.daysTrial} trialConfigId={target.trialConfigId} trialPageId={target.trialPageId} isDisabledButton={isDisabledButton} />;
};
